/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Custom FormFlex component
 */
import React from 'react';
import { Flex, type FlexProps } from 'antd';

type FormFlexProps = FlexProps;

const FormFlex: React.FC<FormFlexProps> = ({ children, gap = 12, wrap = 'wrap', align = 'center', className, ...rest }) => {
	return (
		<Flex gap={gap} wrap={wrap} align={align} className={className} {...rest}>
			{children}
		</Flex>
	);
};

export default FormFlex;
